<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" v-on:input="$emit('updateDialog', false)" max-width="1100px">
      <v-card>
        <v-form v-on:submit.prevent="createItem" ref="modal_form">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row mt-3">
              <div class="col-md-3">
                <!-- READ ONLY -->
                <v-text-field data-vv-as="operacion" label="Operacion*" name="operacion" v-model="item.operacion" v-validate="'required|max:30'" :disabled="true" />
                <span class="red--text">{{ errors.first("operacion") }}</span>
              </div>
              <div class="col-md-3">
                <!-- READ ONLY -->
                <v-combobox
                  v-model="item.shippers"
                  data-vv-as="shippers"
                  name="shippers"
                  item-text="name"
                  item-value="id"
                  :items="shippers"
                  label="Shipper*"
                  v-validate="'required'"
                  autocomplete="off"
                  :disabled="true"
                  multiple
                  small-chips
                ></v-combobox>
                <span class="red--text">{{ errors.first("shippers") }}</span>
              </div>

              <div class="col-md-3">
                <v-combobox
                  v-model="item.consignees"
                  data-vv-as="consignees"
                  name="consignees"
                  item-text="name"
                  item-value="id"
                  v-validate="'required'"
                  :items="consignees"
                  label="Consignee*"
                  autocomplete="off"
                  :disabled="true"
                  multiple
                  small-chips
                ></v-combobox>                
              </div>


              <div class="col-md-3">
                <v-text-field data-vv-as="booking" label="Booking" name="booking" v-model="item.booking" :disabled="true" />
                <span class="red--text">{{ errors.first("booking") }}</span>
              </div>

              <div class="col-md-3">
                <v-combobox
                  v-model="item.puerto_salida"
                  data-vv-as="puerto origen"
                  name="puerto_salida"
                  item-text="name"
                  item-value="id"
                  :items="puertos"
                  label="Puerto de origen"
                  autocomplete="off"
                  :disabled="isViewModal()"
                ></v-combobox>
                <span class="red--text">{{ errors.first("puerto_salida") }}</span>
              </div>              

              <div class="col-md-3">
                <v-combobox
                  v-model="item.puerto_llegada"
                  data-vv-as="puerto destino"
                  name="puerto_llegada"
                  item-text="name"
                  item-value="id"
                  :items="puertos"
                  label="Puerto de destino"
                  autocomplete="off"
                  :disabled="isViewModal()"
                ></v-combobox>
                <span class="red--text">{{ errors.first("puerto_llegada") }}</span>
              </div>

              <div class="col-md-3">
                <!-- READ ONLY -->
                <v-text-field data-vv-as="referencia_cliente" label="Referencia cliente" name="referencia_cliente" v-model="item.referencia_cliente" :disabled="isViewModal()" />
                <span class="red--text">{{ errors.first("referencia_cliente") }}</span>
              </div>

              <div class="col-md-3">
                <!-- espacio para que quede como comercial -->               
              </div>

              <div class="col-md-1">
                <!-- READ ONLY -->
                <v-checkbox label="LCL" :disabled="true" v-model="item.lcl"></v-checkbox>
              </div>

              <div class="col-md-3">
                <!-- READ ONLY -->
                <v-combobox
                  v-model="item.buque_salida"
                  data-vv-as="buque de salida"
                  name="buque_salida"
                  item-text="name"
                  item-value="id"
                  :items="buques"
                  label="Buque de salida"                  
                  autocomplete="off"
                  :disabled="true"                
                ></v-combobox>
                <span class="red--text">{{ errors.first("buque_salida") }}</span>
              </div>              

              <div class="col-md-3">
                <!-- READ ONLY -->
                <v-text-field data-vv-as="master_bl" label="Master BL" name="master_bl" v-model="item.master_bl" :disabled="true" />
                <span class="red--text">{{ errors.first("master_bl") }}</span>
              </div>             

              <div class="col-md-2">
                <v-text-field v-validate="'max:30'" data-vv-as="ncm" label="N.C.M." name="ncm" v-model="item.ncm" :disabled="isViewModal()" />
                <span class="red--text">{{ errors.first("ncm") }}</span>
              </div>  
              
              <div class="col-md-3">
                <v-combobox
                  v-model="item.en_transito"
                  data-vv-as="en transito"
                  name="en_transito"
                  :items="en_transito_combo"
                  label="En transito"                  
                  autocomplete="off"
                  :disabled="isViewModal()"                  
                ></v-combobox>
                <span class="red--text">{{ errors.first("en_transito") }}</span>
              </div> 

              <div class="col-md-12">                
                <v-combobox
                  v-model="item.naviera"
                  data-vv-as="naviera"
                  name="naviera"
                  item-text="name"
                  item-value="id"
                  :items="navieras"
                  label="Naviera"
                  autocomplete="off"   
                  v-validate="'combobox_id'"  
                  :disabled="isViewModal()"             
                ></v-combobox>
                <span class="red--text">{{ errors.first("naviera") }}</span>
              </div>

              <div class="col-md-12">                
                <v-expansion-panels flat>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <p class="mb-0 title-acordion">
                        <b>House BLs</b>
                      </p>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>                      
                      <InputTable
                        :isViewModal="true"
                        :validator="$validator"
                        :headers="[{ text: 'House BL' }, { text: 'Acciones' }]"
                        :items="item.house_bls"
                        :input_fields="[
                          { width: '100%', label: 'House BL', name: 'house_bl', type: 'text', required: false, validate: 'max:30' },                          
                        ]"
                        :item_template="{
                          id: 0,
                          house_bl: '',
                        }"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>    

              <div class="col-md-12">
                <v-textarea outlined data-vv-as="observaciones_housebl" label="Observaciones de House BL" name="observaciones_housebl" v-model="item.observaciones_housebl" :disabled="isViewModal()"></v-textarea>
                <span class="red--text">{{ errors.first("observaciones_housebl") }}</span>
              </div>        

              <div class="col-md-4">
                <!-- READ ONLY -->
                <DatePickerEsp
                  label="Fecha Recoleccion"
                  :date="item.fecha_recoleccion"
                  :isRequired="false"
                  name="fecha_recoleccion"
                  :isViewModal="true"
                  @setDate="
                    (date) => {
                      item.fecha_recoleccion = date;
                    }
                  "
                />
              </div>
              <div class="col-md-4">
                <!-- READ ONLY -->
                <DatePickerEsp
                  label="Fecha Recoleccion (Confirmada)"
                  :date="item.fecha_recoleccion_confirmada"
                  :isRequired="false"
                  name="fecha_recoleccion_confirmada"
                  :isViewModal="true"
                  @setDate="
                    (date) => {
                      item.fecha_recoleccion_confirmada = date;
                    }
                  "
                />
              </div>
              <div class="col-md-4">
                <!-- READ ONLY -->
                <DatePickerEsp
                  label="Fecha Salida (ETD)"
                  :date="item.fecha_salida_etd"
                  :isRequired="false"
                  name="fecha_salida_etd"
                  :isViewModal="true"
                  @setDate="
                    (date) => {
                      item.fecha_salida_etd = date;
                    }
                  "
                />
              </div>
              <div class="col-md-4">
                <DatePickerEsp
                  label="Fecha Salida (ATD)"
                  :date="item.fecha_salida_atd"
                  :isRequired="false"
                  name="fecha_salida_atd"
                  :isViewModal="isViewModal()"
                  @setDate="
                    (date) => {
                      item.fecha_salida_atd = date;
                    }
                  "
                />
              </div>
              <div class="col-md-4">
                <!-- READ ONLY -->
                <DatePickerEsp
                  label="Fecha Llegada (ETA)"
                  :date="item.fecha_llegada_eta"
                  :isRequired="false"
                  name="fecha_llegada_eta"
                  :isViewModal="true"
                  @setDate="
                    (date) => {
                      item.fecha_llegada_eta = date;
                    }
                  "
                />
              </div>
              <div class="col-md-4">
                <DatePickerEsp
                  label="Fecha Llegada (ATA)"
                  :date="item.fecha_llegada_ata"
                  :isRequired="false"
                  name="fecha_llegada_ata"
                  :isViewModal="isViewModal()"
                  @setDate="
                    (date) => {
                      item.fecha_llegada_ata = date;
                    }
                  "
                />
              </div>

              <div class="col-md-12">
                <v-combobox
                  v-model="item.ultimo_estado"
                  data-vv-as="ultimo_estado"
                  name="ultimo_estado"
                  item-text="name"
                  item-value="id"
                  :items="estados"
                  label="Ultimo Estado"
                  autocomplete="off"
                  :disabled="isViewModal()"
                ></v-combobox>
                <span class="red--text">{{ errors.first("ultimo_estado") }}</span>
              </div>              

              <div class="col-md-12">
                <v-textarea outlined data-vv-as="comentarios" label="Comentarios" name="comentarios" v-model="item.comentarios" :disabled="isViewModal()"></v-textarea>
                <span class="red--text">{{ errors.first("comentarios") }}</span>
              </div>                            

              <hr class="mt-4" />
              <div class="col-md-4" v-if="item.lcl">
                <!-- READ ONLY -->
                <v-text-field data-vv-as="bultos" label="Bultos" name="bultos" v-model="item.bultos" v-validate="'integer|min:0'" :disabled="true" />
                <span class="red--text">{{ errors.first("bultos") }}</span>
              </div>

              <div class="col-md-4" v-if="item.lcl">
                <!-- READ ONLY -->
                <v-text-field data-vv-as="kilos" label="Kilos" name="kilos" v-model="item.kilos" v-validate="'integer|min:0'" :disabled="true" />
                <span class="red--text">{{ errors.first("kilos") }}</span>
              </div>

              <div class="col-md-4" v-if="item.lcl">
                <!-- READ ONLY -->
                <v-text-field data-vv-as="m3" label="M3" name="m3" v-model="item.m3" v-validate="'decimal:2|min:0'" :disabled="true" />
                <span class="red--text">{{ errors.first("m3") }}</span>
              </div>

              <div class="col-md-12">                
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <b>Contenedores</b>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <InputTable
                        :isViewModal="isViewModal()"
                        :validator="$validator"
                        :headers="[ { text: 'Nº Contenedor' },{ text: 'Precinto' }, { text: 'Tipo contenedor' },{ text: 'KGs' }, { text: 'M3' }, { text: 'Acciones' }]"
                        :items="item.contenedores"
                        :input_fields="[
                          { label: 'Nº de contenedor', name: 'numero', type: 'text', required: false,validate: 'max:11', regex: '^[a-zA-Z]{4}[0-9]{7}$' },
                          { width: '20%', label: 'Precinto', name: 'id_contenedor', type: 'text', required: false, validate: 'max:11' },
                          { label: 'Tipo contenedor', name: 'tipo_contenedor', type: 'select', required: false, list: tipos_contenedores, list_id: 'id', list_name: 'name' },
                          { label: 'KGs', name: 'kgs', type: 'numeric', required: false, validate: 'decimal:2|min:0' },
                          { label: 'M3', name: 'm3', type: 'numeric', required: false, validate: 'decimal:2|min:0' },
                        ]"
                        :onAddRow="() => {addContenedor()}"
                        :onRemoveRow="() => {removeContenedor()}"
                        :item_template="{
                          id: 0,
                          id_contenedor: '',
                          numero: '',
                          tipo_contenedor: null,
                          kgs: '',
                          33: '',
                        }"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>

              <div class="col-md-12">
                <v-expansion-panels flat>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <p>
                        <b>Buques/Trasbordos</b>
                      </p>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <InputTable
                        :isViewModal="isViewModal()"
                        table_title="Buques"
                        :validator="$validator"
                        :headers="[{ text: 'Fecha Descarga Trasbordo' },{ text: 'Buque de Trasbordo' },{ text: 'Puerto  de Trasbordo' },{ text: 'Fecha Carga de Trasbordo' },{ text: 'Destino Final' }, { text: 'Acciones' }]"
                        :items="item.historial_buques"
                        :input_fields="[                          
                          { label: 'Fecha Descarga Trasbordo', name: 'fecha_descarga_trasbordo', type: 'date', required: false, onChangeValidate: customValidateTrasbordos },
                          { label: 'Buque de Trasbordo', name: 'buque', type: 'select', required: true, list: buques, list_id: 'id', list_name: 'name' },
                          { label: 'Puerto  de Trasbordo', name: 'puerto_trasbordo', type: 'select', required: false, list: puertos, list_id: 'id', list_name: 'name' },
                          { label: 'Fecha Carga Trasbordo', name: 'fecha_carga_trasbordo', type: 'date', required: true, onChangeValidate: customValidateTrasbordos },
                          { label: 'Destino Final', name: 'puerto_destino', type: 'select', required: false, list: puertos, list_id: 'id', list_name: 'name' },
                        ]"
                        :item_template="{
                          id: 0,                        
                          fecha_descarga_trasbordo: null,
                          buque: null,
                          puerto_trasbordo: null,
                          fecha_carga_trasbordo: null,
                          puerto_destino: null,                          
                        }"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>

              <div class="col-md-12">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <b>Packing List</b>
                    </v-expansion-panel-header>
                    <!-- READ ONLY -->
                    <v-expansion-panel-content>
                      <InputTable
                        :isViewModal="true"
                        table_title="Packing List"
                        :validator="$validator"
                        :headers="[{ text: 'Adjunto' }, { text: 'Acciones' }]"
                        :items="item.packing_lists"
                        :input_fields="[
                          {
                            label: 'Seleccionar packing list',
                            name: 'packing_list_attached',
                            name_attached: 'packing_list_path',
                            type: 'file',
                            required: false,
                            allowed_mime_types: ['application/pdf', 'image/jpg', 'image/png'],
                          },
                        ]"
                        :item_template="{
                          id: 0,
                          packing_list_attached: null,
                        }"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>

              <div class="col-md-12">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <b>Documentos</b>
                    </v-expansion-panel-header>
                    <!-- READ ONLY -->
                    <v-expansion-panel-content>
                      <InputTable
                        :isViewModal="true"
                        table_title="Documento"
                        :validator="$validator"
                        :headers="[{ text: 'Adjunto' }, { text: 'Acciones' }]"
                        :items="item.documentos"
                        :input_fields="[
                          {
                            label: 'Seleccionar archivo',
                            name: 'documento_attached',
                            name_attached: 'documento_path',
                            type: 'file',
                            required: false,
                            allowed_mime_types: ['application/pdf', 'image/jpg', 'image/png'],
                          },
                        ]"
                        :item_template="{
                          id: 0,
                          documento_attached: null,
                        }"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>

              <div class="col-md-12">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <b> Facturas</b>
                      <!-- READ ONLY -->
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <InputTable
                        :isViewModal="true"
                        table_title="Facturas"
                        :validator="$validator"
                        :headers="[{ text: 'Nº Factura' }, { text: 'Adjunto' }, { text: 'Acciones' }]"
                        :items="item.facturas"
                        :input_fields="[
                          { width: '20%', label: 'Nº de Factura*', name: 'nro_factura', type: 'text', required: false, validate: 'max:30' },
                          {
                            label: 'Seleccionar archivo',
                            name: 'factura_attached',
                            name_attached: 'factura_path',
                            type: 'file',
                            required: false,
                            allowed_mime_types: ['application/pdf', 'image/jpg', 'image/png'],
                          },
                        ]"
                        :item_template="{
                          id: 0,
                          nro_factura: '',
                          factura_attached: null,
                        }"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>

              <div class="col-md-12">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <b>Facturas de Agente</b>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <InputTable
                        :isViewModal="isViewModal()"
                        table_title="Facturas de Agente"
                        :validator="$validator"
                        :headers="[{ text: 'Nº Factura' }, { text: 'Adjunto' }, { text: 'Autorizado' }, { text: 'Acciones' }]"
                        :items="item.facturas_agentes"
                        :input_fields="[
                          { width: '20%', label: 'Nº de Factura*', name: 'nro_factura', type: 'text', required: false, validate: 'max:30' },
                          {
                            label: 'Seleccionar archivo',
                            name: 'factura_agente_attached',
                            name_attached: 'factura_path',
                            type: 'file',
                            required: false,
                            allowed_mime_types: ['application/pdf', 'image/jpg', 'image/png'],
                          },
                          { width: '5%', label: 'Autorizado', name: 'autorizado', type: 'checkbox', required: false, disabled: true },
                        ]"
                        :item_template="{
                          id: 0,
                          nro_factura: '',
                          factura_agente_attached: null,
                        }"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>

              <div class="col-md-12">
                <v-checkbox label="SIM" :disabled="isViewModal()" v-model="item.sim"></v-checkbox>
              </div>

              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <v-checkbox label="Pago MANI" :disabled="isViewModal()" v-model="item.pago_mani"></v-checkbox>
                  </div>
                  <div class="col-md-4">
                    <DatePickerEsp
                      label="Fecha Carga Mani"
                      :date="item.fecha_carga_mani"
                      :isRequired="false"
                      name="fecha_carga_mani"
                      :isViewModal="isViewModal()"
                      @setDate="
                        (date) => {
                          item.fecha_carga_mani = date;
                        }
                      "
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <b>MANI</b>
                    </v-expansion-panel-header>
                    <!-- READ ONLY -->
                    <v-expansion-panel-content>
                      <InputTable
                        :isViewModal="isViewModal()"
                        table_title="MANI"
                        :validator="$validator"
                        :headers="[{ text: 'Adjunto' }, { text: 'Acciones' }]"
                        :items="item.manis"
                        :input_fields="[
                          {
                            label: 'Seleccionar archivo',
                            name: 'mani_attached',
                            name_attached: 'mani_path',
                            type: 'file',
                            required: false,
                            allowed_mime_types: ['application/pdf', 'image/jpg', 'image/png'],
                          },
                        ]"
                        :item_template="{
                          id: 0,
                          mani_attached: null,
                        }"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>

              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <v-checkbox label="Proformas Control" :disabled="isViewModal()" v-model="item.proformas_control"></v-checkbox>
                  </div>

                  <div class="col-md-4">
                    <v-text-field data-vv-as="proformas_numero" label="Proformas Nº" name="proformas_numero" v-model="item.proformas_numero" :disabled="isViewModal()" />
                    <span class="red--text">{{ errors.first("proformas_numero") }}</span>                    
                  </div>

                  <div class="col-md-4 mt-5 text-center" v-if="isViewModal() && item.proformas_path != null">
                    Proforma Adjunto
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-5" medium color="blue" @click="download(item.proformas_url, item.id)"> mdi-download </v-icon>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </div>

                  <div class="col-md-4" v-if="!isViewModal()">
                    <v-file-input class="float-left" style="width: 80%" truncate-max="15" name="proformas_attached" accept="application/pdf" v-model="item.proformas_attached" label="Seleccione Adjunto Proforma"></v-file-input>
                    <span class="red--text">{{ errors.first("proformas_attached") }}</span>
                    <v-tooltip bottom v-if="item.proformas_path != null">
                      <template v-slot:activator="{ on }">
                        <v-btn class="mt-2 ml-3" v-on="on" outlined small fab dark color="blue-grey" @click="download(item.proformas_url, item.id)">
                          <v-icon medium color="blue"> mdi-download </v-icon>
                        </v-btn>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="row">
                  <div class="col">
                    <v-combobox
                      v-model="item.emision_mbl"
                      data-vv-as="emision_mbl"
                      name="emision_mbl"
                      item-text="name"
                      item-value="id"
                      :items="emisiones_mbl"
                      label="Emision MBL"
                      autocomplete="off"
                      v-validate="'combobox_id'"
                      :disabled="isViewModal()"
                    ></v-combobox>
                    <span class="red--text">{{ errors.first("emision_mbl") }}</span>             
                  </div>

                  <div class="col">                   
                    <v-text-field data-vv-as="doc" label="DOC" name="doc" v-model="item.doc" :disabled="isViewModal()" />
                    <span class="red--text">{{ errors.first("doc") }}</span>
                  </div>
                  
                  <div class="col">
                    <DatePickerEsp
                      label="Fecha Recibido/Confirmar"
                      :date="item.fecha_recibido_confirmar"
                      :isRequired="false"
                      name="fecha_recibido_confirmar"
                      :isViewModal="isViewModal()"
                      @setDate="
                        (date) => {
                          item.fecha_recibido_confirmar = date;
                        }
                      "
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <DatePickerEsp
                  label="Fecha Envio Doc Oficina Centro"
                  :date="item.fecha_envio_doc_oficina_centro"
                  :isRequired="false"
                  name="fecha_envio_doc_oficina_centro"
                  :isViewModal="isViewModal()"
                  @setDate="
                    (date) => {
                      item.fecha_envio_doc_oficina_centro = date;
                    }
                  "
                />
              </div>              

              <div class="col-md-4">
                <v-combobox
                  v-model="item.terminal_dep_fiscal"
                  data-vv-as="terminal_dep_fiscal"
                  name="terminal_dep_fiscal"
                  item-text="name"
                  item-value="id"
                  :items="terminales_dep_fiscal"
                  label="Terminal/Dep. Fiscal"
                  autocomplete="off"
                  :disabled="isViewModal()"
                ></v-combobox>
                <span class="red--text">{{ errors.first("terminal_dep_fiscal") }}</span>
              </div>

              <div class="col-md-12">
                <v-textarea outlined data-vv-as="observaciones" label="Observaciones" name="observaciones" v-model="item.observaciones" :disabled="isViewModal()"></v-textarea>
                <span class="red--text">{{ errors.first("observaciones") }}</span>
              </div>

              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <v-text-field data-vv-as="viaje_arribo_puerto" label="Viaje Arribo Puerto" name="viaje_arribo_puerto" v-model="item.viaje_arribo_puerto" :disabled="isViewModal()" />
                    <span class="red--text">{{ errors.first("viaje_arribo_puerto") }}</span>
                  </div>

                  <div class="col-md-4">
                    <v-combobox
                      v-model="item.codigo_puerto"
                      data-vv-as="codigo_puerto"
                      name="codigo_puerto"
                      item-text="name"
                      item-value="id"
                      :items="codigos_puertos"
                      label="Codigo Puerto"
                      autocomplete="off"
                      :disabled="isViewModal()"
                    ></v-combobox>
                    <span class="red--text">{{ errors.first("codigo_puerto") }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <DatePickerEsp
                  label="Fecha Transmision Anticipada"
                  :date="item.fecha_transmision_anticipada"
                  :isRequired="false"
                  name="fecha_transmision_anticipada"
                  :isViewModal="isViewModal()"
                  @setDate="
                    (date) => {
                      item.fecha_transmision_anticipada = date;
                    }
                  "
                />
              </div>

              <div class="col-md-4">
                <v-combobox
                  v-model="item.agente"
                  data-vv-as="agente"
                  name="agente"
                  item-text="name"
                  item-value="id"
                  :items="agentes"
                  label="Agente*"
                  autocomplete="off"
                  :disabled="isViewModal()"
                ></v-combobox>
                <span class="red--text">{{ errors.first("agente") }}</span>
              </div>

              <div class="col-md-12">
                <v-expansion-panels flat>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <p class="mb-0 title-acordion">
                        <b>Documentaciones de Entrega</b>
                      </p>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>                      
                      <InputTable
                        :isViewModal="isViewModal()"
                        table_title="Documentacion de Entrega"
                        :validator="$validator"
                        :headers="[{ text: 'Fecha' }, { text: 'Adjunto' },{ text: 'Acciones' }]"
                        :items="item.documentaciones_entrega"
                        :input_fields="[
                          { width: '20%', label: 'Fecha', name: 'fecha', type: 'date', required: false },
                          {
                            label: 'Seleccionar archivo',
                            name: 'adjunto_attached',
                            name_attached: 'factura_path',
                            type: 'file',
                            required: false,
                            allowed_mime_types: ['application/pdf', 'image/jpg', 'image/png'],
                          },
                          
                        ]"
                        :item_template="{
                          id: 0,
                          fecha: '',
                          adjunto_attached: null,                            
                        }"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div> 
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <!--<v-btn color="warning" text @click="nextModal(item)" v-if="!isViewModal() && this.item.id == 0">Siguiente</v-btn>-->
            <v-btn color="success" :loading="submit_loading" text type="submit" v-if="!isViewModal()">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { filesService } from "@/libs/ws/filesService";
import { ordersGeneralService } from "@/libs/ws/ordersGeneralService";
import { generalService } from "@/libs/ws/generalService";
import DatePickerEsp from "@/components/DatePickerEsp.vue";
import ModalMixin from "@/mixins/ModalMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import InputTable from "@/components/InputTable.vue";

export default {
  mixins: [ModalMixin, RolMixin],
  components: { DatePickerEsp, InputTable },
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
    print: Function,
  },
  data() {
    return {
      menu: false,
      show: false,
      shippers: [],
      consignees: [],
      estados: [],
      emisiones_mbl: [
        { id: 'Origen', name: "Origen" },
        { id: 'Destino', name: "Destino" },
      ],
      puertos: [],
      buques: [],
      tipos_contenedores: [],
      navieras: [],
      codigos_puertos: [],
      agentes: [],
      terminales_dep_fiscal: [],
      en_transito_combo: [],
    };
  },
  watch: {
    item: {
      handler(val) {
        this.$emit("updateItem", this.item);
      },
      deep: true,
    },

    dialog() {
      if(this.dialog){
        this.loadComboData();
      }
      this.errors.clear();
    },
  },
  mounted() {
    this.loadComboData();
  },
  methods: {
    customValidateTrasbordos(name_field, item){      
      if(item.fecha_descarga_trasbordo != null && item.fecha_carga_trasbordo != null){
        if(item.fecha_descarga_trasbordo > item.fecha_carga_trasbordo){
          this.showError(name_field,"La fecha de carga de trasbordo debe ser mayor a la fecha de descarga de trasbordo");
          return false;
        }
      }

      this.removeErrorFromValidator(name_field);      
      if(name_field.includes('fecha_descarga')){
        this.removeErrorFromValidator(name_field.replace('fecha_descarga','fecha_carga'));
      }else{
        this.removeErrorFromValidator(name_field.replace('fecha_carga','fecha_descarga'));
      }
      

      return true;
    },
    setDateValue(value, name) {
      this.item[name] = value;
    },
    isViewModal() {
      return this.formBtn == "";
    },
    loadComboData() {
      ordersGeneralService.getEnTransito().then((response) => {
        this.en_transito_combo = response.result;
      });
      generalService.filter({}, "shippers").then((response) => {
        this.shippers = response.result;
      });
      generalService.filter({}, "estados").then((response) => {
        this.estados = response.result;
      });
      generalService.filter({}, "puertos").then((response) => {
        this.puertos = response.result;
      });
      generalService.filter({}, "consignees").then((response) => {
        this.consignees = response.result;
      });
      generalService.filter({}, "buques").then((response) => {
        this.buques = response.result;
      });
      generalService.filter({}, "tipos_contenedores").then((response) => {
        this.tipos_contenedores = response.result;
      });

      generalService.filter({}, "navieras").then((response) => {
        this.navieras = response.result;
      });
      generalService.filter({}, "codigos_puertos").then((response) => {
        this.codigos_puertos = response.result;
      });
      generalService.filter({}, "agentes").then((response) => {
        this.agentes = response.result;
      });
      generalService.filter({}, "terminales_dep_fiscal").then((response) => {
        this.terminales_dep_fiscal = response.result;
      });
    },
    customValidate(){
      var result = true;
      
      for(var s = 0; s < this.item.shippers.length; s++){
        result = result && this.customValidateComboBoxField(this.item.shippers[s],"shippers","Shippers", false,true);
      }
      for(var cc = 0; cc < this.item.consignees.length; cc++){
        result = result && this.customValidateComboBoxField(this.item.consignees[cc],"consignees","Consignees", false,true);
      }

      result = result && this.customValidateComboBoxField(this.item.ultimo_estado,"ultimo_estado","Ultimo Estado");
      result = result && this.customValidateComboBoxField(this.item.puerto_salida,"puerto_salida","Puerto de salida");
      result = result && this.customValidateComboBoxField(this.item.puerto_llegada,"puerto_llegada","Puerto de llegada");

      result = result && this.customValidateComboBoxField(this.item.agente,"agente","Agente");
      result = result && this.customValidateComboBoxField(this.item.terminal_dep_fiscal,"terminal_dep_fiscal","Terminal/Dep. Fiscal");
      result = result && this.customValidateComboBoxField(this.item.codigo_puerto,"codigo_puerto","Codigo Puerto"); 
      result = result && this.customValidateComboBoxField(this.item.naviera,"naviera","Naviera");                   

      if(this.item.contenedores != null && this.item.contenedores.length > 0){
        for(var c = 0; c < this.item.contenedores.length; c++){          
          result = result && this.customValidateComboBoxField(this.item.contenedores[c].tipo_contenedor,'tipo_contenedor_' + c,"Tipo de conenedor");
        }
      }

      if(this.item.historial_buques != null && this.item.historial_buques.length > 0){
        for(var i = 0; i < this.item.historial_buques.length; i++){
          
          result = result && this.customValidateComboBoxField(this.item.historial_buques[i].buque,'buque_' + i,"buque");
          result = result && this.customValidateComboBoxField(this.item.historial_buques[i].puerto_trasbordo,'puerto_trasbordo_' + i,"puerto_trasbordo");
          result = result && this.customValidateComboBoxField(this.item.historial_buques[i].puerto_destino,'puerto_destino_' + i,"puerto_destino");          

          if(this.item.historial_buques[i].fecha_carga_trasbordo == null){
            this.showError('fecha_carga_trasbordo_' + i,"La fecha de carga de trasbordo no puede ser vacia");
            result = result && false;
          }

          result = result && this.customValidateTrasbordos('fecha_carga_trasbordo_' + i, this.item.historial_buques[i]);
        }
      }      
      return result;
    },
    createItem(e, nextFlag = false) {
      return this.$validator.validateAll().then((valid) => {
        if (valid && this.customValidate()) {
          if (e != null) e.preventDefault();
          if (!this.item.isExternal) {
            this.item.companyExternal = { name: "", id: 1 };
          }
          this.setLoading(true);

          let data = new FormData();
          data.append("id", this.item.id);
          data.append("operacion", this.item.operacion);
          data.append("shippers_arr", JSON.stringify(this.item.shippers));
          data.append("consignees_arr", JSON.stringify(this.item.consignees));

          if (this.item.historial_buques.length > 0) {
            for (var b = 0; b < this.item.historial_buques.length; b++) {
              data.append("historial_buques_arr[]", JSON.stringify(this.item.historial_buques[b]));
            }
          }

          data.append("sim", this.item.sim ? 1 : 0);
          data.append("pago_mani", this.item.pago_mani ? 1 : 0);
          data.append("proformas_control", this.item.proformas_control ? 1 : 0);
          data.append("courier_control", this.item.courier_control ? 1 : 0);

          if (this.item.referencia_cliente != null) data.append("referencia_cliente", this.item.referencia_cliente);

          if (this.item.fecha_salida_atd != null)
            data.append("fecha_salida_atd", this.item.fecha_salida_atd);

          if (this.item.proformas_numero != null) data.append("proformas_numero", this.item.proformas_numero);
          if (this.item.ncm != null) data.append("ncm", this.item.ncm);
          if (this.item.en_transito != null) data.append("en_transito", this.item.en_transito);
          if (this.item.observaciones_housebl != null) data.append("observaciones_housebl", this.item.observaciones_housebl);
          if (this.item.doc != null) data.append("doc", this.item.doc);
          if (this.item.emision_mbl != null) data.append("emision_mbl", (this.item.emision_mbl != null ? this.item.emision_mbl.id : ""));
          if (this.item.observaciones != null) data.append("observaciones", this.item.observaciones);
          if (this.item.viaje_arribo_puerto != null) data.append("viaje_arribo_puerto", this.item.viaje_arribo_puerto);

          if (this.item.courier_attached != null) data.append("courier_attached", this.item.courier_attached);
          if (this.item.proformas_attached != null) data.append("proformas_attached", this.item.proformas_attached);

          if (this.item.fecha_carga_mani != null) data.append("fecha_carga_mani", this.item.fecha_carga_mani);
          if (this.item.fecha_recibido_confirmar != null) data.append("fecha_recibido_confirmar", this.item.fecha_recibido_confirmar);
          if (this.item.fecha_envio_doc_oficina_centro != null) data.append("fecha_envio_doc_oficina_centro", this.item.fecha_envio_doc_oficina_centro);
          if (this.item.fecha_transmision_anticipada != null) data.append("fecha_transmision_anticipada", this.item.fecha_transmision_anticipada);
          
          if (this.item.ultimo_estado != null) data.append("ultimo_estado_id", this.item.ultimo_estado.id);
          if (this.item.puerto_salida != null) data.append("puerto_salida_id", this.item.puerto_salida.id);
          if (this.item.puerto_llegada != null) data.append("puerto_llegada_id", this.item.puerto_llegada.id);
          
          if (this.item.agente != null) data.append("agente_id", this.item.agente.id);
          if (this.item.terminal_dep_fiscal != null) data.append("terminal_dep_fiscal_id", this.item.terminal_dep_fiscal.id);
          if (this.item.codigo_puerto != null) data.append("codigo_puerto_id", this.item.codigo_puerto.id);

          if (this.item.fecha_llegada_eta != null) data.append("fecha_llegada_eta", this.item.fecha_llegada_eta);          
          if (this.item.fecha_llegada_ata != null) data.append("fecha_llegada_ata", this.item.fecha_llegada_ata);
          if (this.item.comentarios != null) data.append("comentarios", this.item.comentarios);

          if (this.item.cantidad_contenedores != null) data.append("cantidad_contenedores", this.item.cantidad_contenedores);
          data.append("cantidad_contenedores_arr", this.item.contenedores.length);          
          if (this.item.contenedores.length > 0) {
            for (var i = 0; i < this.item.contenedores.length; i++) {
              data.append("contenedores_arr[]", JSON.stringify(this.item.contenedores[i]));
            }
          }

          //no se pueden adjuntar archivos en un array anidado
          data.append("cantidad_facturas_agente", this.item.facturas_agentes.length);
          if (this.item.facturas_agentes.length > 0) {
            for (var j = 0; j < this.item.facturas_agentes.length; j++) {
              data.append("facturas_agentes_" + j + "_id", this.item.facturas_agentes[j].id);
              data.append("facturas_agentes_" + j + "_nro_factura", this.item.facturas_agentes[j].nro_factura);
              data.append("facturas_agentes_" + j + "_attached", this.item.facturas_agentes[j].factura_agente_attached);              
            }
          }

          //no se pueden adjuntar archivos en un array anidado
          data.append("cantidad_manis", this.item.manis.length);
          if (this.item.manis.length > 0) {
            for (var v = 0; v < this.item.manis.length; v++) {
              data.append("mani_" + v + "_id", this.item.manis[v].id);
              data.append("mani_" + v + "_attached", this.item.manis[v].manis_attached);
            }
          }

          data.append("cantidad_documentaciones_entrega", this.item.documentaciones_entrega.length);
          if (this.item.documentaciones_entrega.length > 0) {
            for (var z = 0; z < this.item.documentaciones_entrega.length; z++) {              
              data.append("documentaciones_entrega_" + z + "_id", this.item.documentaciones_entrega[z].id);
              data.append("documentaciones_entrega_" + z + "_fecha", this.item.documentaciones_entrega[z].fecha);
              data.append("documentaciones_entrega_" + z + "_attached", this.item.documentaciones_entrega[z].adjunto_attached);              
            }
          }

          if (this.item.id > 0) {
            return this.service
              .update(data)
              .then((response) => {
                if (response.status == true) {
                  this.$toast.success("El " + this.modal_title + " se modifico correctamente.", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
              })
              .catch((response) => {
                this.$toast.error(response.msg, "Error");
              })
              .finally(() => this.setLoading(false));
          } else {
            return this.service
              .create(data)
              .then((response) => {
                console.log(response);
                if (response.status && response.result.id > 0) {
                  this.$toast.success("El " + this.modal_title + " se creo correctamente", "OK");
                  this.$emit("updateDialog", false, nextFlag);
                  this.$emit("loadList");
                  if (nextFlag) this.$validator.reset();
                  return response;
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                  return response;
                }
              })
              .catch((response) => {
                console.log(response);
                this.$toast.error(response.msg, "Error");
                return response;
              })
              .finally(() => this.setLoading(false));
          }
        }else{
          this.$toast.error("Por favor complete los campos obligatorios o verifique el formato de los valores ingresados", "Error");
        }
      });
    },

    printModal() {
      this.createItem(null).then((response) => {
        this.$emit("print", response.result, "pdf");
      });
    },

    nextModal() {
      this.createItem(null, true);
    },
    addContenedor(){
      if(this.cantidad_contenedores == null)
        this.cantidad_contenedores = 0;

      this.cantidad_contenedores = this.cantidad_contenedores + 1;      
    },
    removeContenedor(){
      this.cantidad_contenedores = this.cantidad_contenedores - 1;      
      if(this.cantidad_contenedores == 0)
        this.cantidad_contenedores = null;
    },
    download(url, name) {
      console.log(url);
      this.loading = true;
      filesService
        .downloadOVHFile(url)
        .then((response) => {
          console.log(response.data);

          let blob = new Blob([response.data], {
            type: "application/pdf", //TODO: change for attachment
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = name;
          link.click();
        })
        .catch((response) => {
          this.$toast.error(response.msg, "Error");
        })
        .finally(() => (this.loading = false));
    }
  },
};
</script>
